import { Component } from "@angular/core";
import {
  ViewController,
  LoadingController,
  AlertController,
  NavController,
  Platform,
} from "ionic-angular";

// O provider para se comunicar com o servidor online
import { ApiProvider } from "../../providers/api/api";

// Salvar no storage
import { Storage } from "@ionic/storage";

import { TranslateMsgProvider } from "../../providers/translate-msg/translate-msg";

import { EsqueceusenhaPage } from "../esqueceusenha/esqueceusenha";
import { TabsPage } from "../tabs/tabs";

@Component({
  selector: "page-loginpadrao",
  templateUrl: "loginpadrao.html",
})
export class LoginpadraoPage {
  registerCredentials = { email: "", senha: "" };
  imagem;
  loading;

  constructor(
    public viewCtrl: ViewController,
    private _apiService: ApiProvider,
    private loadingCtrl: LoadingController,
    private storage: Storage,
    private alertCtrl: AlertController,
    private _msg: TranslateMsgProvider,
    private nav: NavController,
    public platform: Platform
  ) {
    this._apiService.getLogo().subscribe((arg) => {
      this.imagem = arg.config.imagem;
    });
  }

  /* Main */
  public login() {
    // Exibe mensagem de carregando
    this.showLoading();

    var emailTest =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    /* Verifica se não está null*/
    if (
      this.registerCredentials.email === null ||
      this.registerCredentials.senha === null
    ) {
      this.showPopup(this._msg.getMsg("ERRO"), this._msg.getMsg("ERRO_DADOS"));
    } else if (!emailTest.test(this.registerCredentials.email)) {
    /* Verifica se o email é valido */
      this.showPopup(this._msg.getMsg("ERRO"), this._msg.getMsg("ERRO_EMAIL"));
    } else {
      this._apiService.login(this.registerCredentials).subscribe((arg) => {
        if (!arg.status) {
          // Erro
          this.showPopup(this._msg.getMsg("ERRO"), arg.erro);
        } else {
          this.storage.set("id_cliente", arg.cliente.id_cliente);
          this.storage.set("nome", arg.cliente.nome);
          this.storage.set("facebook", 0);

          this.nav.setRoot(TabsPage);
        }
      });
    }
  }

  /* Exibe mensagem de loading*/
  showLoading() {
    this.loading = this.loadingCtrl.create({
      content: this._msg.getMsg("CARREGANDO") + "...",
      dismissOnPageChange: true,
    });
    this.loading.present();
  }

  /* Exibe erro */
  showPopup(titulo, text) {
    this.loading.dismiss();

    let alert = this.alertCtrl.create({
      title: titulo,
      subTitle: text,
      buttons: ["OK"],
    });
    alert.present();
  }

  // Fecha modal
  esqueceuSenha() {
    this.nav.push(EsqueceusenhaPage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/loginpadrao/loginpadrao.ts